var _circle, _circle2, _rect, _circle3, _rect2, _circle4, _circle5, _rect3, _rect4, _circle6, _circle7, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransactionsPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icon-color",
    cx: 20.0449,
    cy: 13.5,
    r: 1.75,
    stroke: "#6D757D",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "icon-color",
    cx: 20.0449,
    cy: 20,
    r: 2.25,
    stroke: "#6D757D",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "icon-path",
    x: 20.7949,
    y: 15,
    width: 3,
    height: 1.5,
    transform: "rotate(90 20.7949 15)",
    fill: "#6D757D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "icon-color",
    cx: 20.0449,
    cy: 26.5,
    r: 1.75,
    transform: "rotate(-180 20.0449 26.5)",
    stroke: "#6D757D",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "icon-path",
    x: 19.2949,
    y: 25,
    width: 3,
    height: 1.5,
    transform: "rotate(-90 19.2949 25)",
    fill: "#6D757D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "icon-color",
    cx: 25.6738,
    cy: 16.75,
    r: 1.75,
    transform: "rotate(60 25.6738 16.75)",
    stroke: "#6D757D",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "icon-color",
    cx: 2.5,
    cy: 2.5,
    r: 1.75,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 13.5 13.335)",
    stroke: "#6D757D",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "icon-path",
    x: 24.75,
    y: 18.1494,
    width: 3,
    height: 1.5,
    transform: "rotate(150 24.75 18.1494)",
    fill: "#6D757D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "icon-path",
    width: 3,
    height: 1.5,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 15.3398 18.1494)",
    fill: "#6D757D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "icon-color",
    cx: 14.4151,
    cy: 23.25,
    r: 1.75,
    transform: "rotate(-120 14.4151 23.25)",
    stroke: "#6D757D",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "icon-color",
    cx: 2.5,
    cy: 2.5,
    r: 1.75,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 26.5889 26.665)",
    stroke: "#6D757D",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "icon-path",
    x: 15.3398,
    y: 21.8506,
    width: 3,
    height: 1.5,
    transform: "rotate(-30 15.3398 21.8506)",
    fill: "#6D757D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "icon-path",
    width: 3,
    height: 1.5,
    transform: "matrix(-0.866026 -0.5 -0.5 0.866026 24.75 21.8506)",
    fill: "#6D757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionsPool);
export default __webpack_public_path__ + "static/media/icon-transactions-pool.32791aa84c7d213407e93a8bffd577fc.svg";
export { ForwardRef as ReactComponent };